<template>
  <div class="flex justify-center items-center mb-36">
<!--    <PaginationButton-->
<!--      @click="changePage(1)"-->
<!--      :disabled="currentPage === 1"-->
<!--    >-->
<!--      {{ $t("pagination.first") }}-->
<!--    </PaginationButton>-->
    
    <PaginationButton
      v-for="page in pagesToShow"
      :key="page"
      @click="changePage(page)"
      :disabled="page === currentPage"
      :is-active="currentPage === page"
    >
      {{ page }}
    </PaginationButton>
    
<!--    <PaginationButton-->
<!--      @click="changePage(totalPages)"-->
<!--      :disabled="currentPage === totalPages"-->
<!--    >-->
<!--      {{ $t("pagination.last") }}-->
<!--    </PaginationButton>-->
  </div>
</template>

<script>
import PaginationButton from './PaginationButton.vue'

export default {
  name: "PaginationDefault",
  components: {
    PaginationButton
  },
  props: {
    total: Number,
    count: Number,
    perPage: Number,
    currentPage: Number,
    totalPages: Number,
    lastPage: Number,
    from: Number,
    to: Number
  },
  computed: {
    pagesToShow() {
      let startPage = Math.max(this.currentPage - 2, 1);
      let endPage = Math.min(this.currentPage + 2, this.totalPages);

      let pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      // Always include the first and last page
      if (!pages.includes(1)) {
        pages.unshift(1);
      }
      if (!pages.includes(this.totalPages)) {
        pages.push(this.totalPages);
      }

      return pages;
    }
  },
  methods: {
    changePage(page) {
      if (this.currentPage === page) return;
      this.$emit("change", page);
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped>
.border {
  border: 1px solid #ccc;
}

.rounded {
  border-radius: 5px;
}

.px-3 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
</style>
